import { render, staticRenderFns } from "./registrar_beneficiarios.vue?vue&type=template&id=25969aa2&scoped=true"
import script from "./registrar_beneficiarios.vue?vue&type=script&lang=js"
export * from "./registrar_beneficiarios.vue?vue&type=script&lang=js"
import style0 from "./registrar_beneficiarios.vue?vue&type=style&index=0&id=25969aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25969aa2",
  null
  
)

export default component.exports